import { useWindowSize } from "@react-hookz/web";
import { Checkbox, Input, Label } from "@rebass/forms";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { BsChevronUp, BsSliders } from "react-icons/bs";
import { HiSearch } from "react-icons/hi";
import Select, { components } from "react-select";
import { Box, Flex, Text, Button } from "rebass";
import Bin from "../../icons/Bin";
import {
  default as ChecvronDown,
  default as ChevronDown,
} from "../../icons/ChevronDown";
import Search from "../../icons/Search";
import { getLocalizedString } from "../../utils";
import Chip from "../common/Chip";
import useResponsive from "../../hooks/useResponsive";
import { Avatar } from "../common/Avatar";
import { useDispatch, useSelector } from "react-redux";
import { yodaAgentActions } from "../../logic/actions";
import { AiOutlineClose } from "react-icons/ai";
import FiltersAndSearchMobile from "../common/FiltersAndSearchMobile";
import useFiltersAndSearchMobile from "../../hooks/useFiltersAndSearchMobile";

function UsersFilter({ filterUsers }) {
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("all");
  const searchBox = useRef();
  const checkRef = useRef();
  const inputRef = useRef();

  const [agent, setAgent] = useState("");
  const [agentCode, setAgentCode] = useState("");
  const [openSearchMobile, setOpenSearchMobile] = useState(false);
  const [openFilterMobile, setOpenFilterMobile] = useState(false);
  const [checkbox, setCheckbox] = useState(null);

  const { isMobile, isTabletSm } = useResponsive();
  const filterProps = useFiltersAndSearchMobile();

  const dispatch = useDispatch();

  const { agents } = useSelector((state) => state.yodaAgent);

  useEffect(() => {
    dispatch(yodaAgentActions.getAll());
  }, []);

  useEffect(() => {
    agents?.map((agent) => {
      if (agent.id == localStorage.getItem("selectedAgent")) {
        setAgent(agent.firstName);
        setAgentCode(agent.name);
      }
    });
  }, [agents]);

  useEffect(() => {
    filterUsers(query.toString().toLowerCase(), status);
  }, [query, status]);

  const statusSelectStyle = {
    input: (styles) => ({
      ...styles,
    }),
    control: (styles) => ({
      ...styles,
      border: 0,
      borderRadius: 0,
      backgroundColor: "white",
      fontSize: 12,
      marginTop: 0,
      boxShadow: "none",
    }),
    menu: (styles) => ({
      ...styles,
      border: "1px solid rgba(0,0,0,.2)",
      padding: 0,
      borderRadius: 0,
      fontSize: 12,
      marginTop: 0,
      marginBottom: 0,
      boxShadow: "none",
    }),
    option: (styles) => ({
      ...styles,
      marginTop: 1,
      marginBottom: 1,
    }),
  };
  const userStatusList = [
    { value: "all", label: getLocalizedString("Tutti").toUpperCase() },
    {
      value: "Non Bloccante",
      label: getLocalizedString("Affidabili").toUpperCase(),
      color: "#dcdcdc",
    },
    {
      value: "Warning",
      label: getLocalizedString("Inaffidabili").toUpperCase(),
      color: "#e2ba16",
    },
    {
      value: "Bloccante",
      label: getLocalizedString("Bloccati").toUpperCase(),
      color: "#f85959",
    },
  ];

  const activeFilters = useMemo(() => {
    let filters = [];
    if (status && status !== "all") {
      filters.push({
        value: "status",
        text: userStatusList.find((item) => item.value === status).label,
      });
    }
    if (query) {
      filters.push({
        value: "search",
        text: query,
      });
    }
    return filters;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, status]);

  function changeQuery(e) {
    if (e.keyCode === 13) {
      setQuery(e.target.value);

      if (isMobile || isTabletSm) inputRef.current.value = "";
      setOpenSearchMobile(false);
    }
  }

  function sendBtn() {
    const q = inputRef.current.value;
    setQuery(q);
    filterProps.setOpenSearch(false);
  }

  function changeQueryClick() {
    setQuery(searchBox.current.value);
  }

  function clearQuery() {
    setQuery("");
    searchBox.current.value = "";
    setStatus("all");
    setCheckbox(null);
  }

  function statusHandler(value, i) {
    if (checkbox === i) {
      setStatus("all");
      setCheckbox(null);
      return;
    }
    setStatus(value);
    setCheckbox(i);
  }

  function rmvHandler(value) {
    if (value === "status") setStatus("all");
    else if (value === "search") setQuery("");
  }

  function clearFilters() {
    setStatus("all");
    setQuery("");
  }

  const openFilters = () => {
    setOpenFilterMobile((toggle) => !toggle);
    setOpenSearchMobile(false);
  };

  const openSearch = () => {
    setOpenFilterMobile(false);
    setOpenSearchMobile((toggle) => !toggle);
  };

  return (
    <>
      <Flex
        width={1}
        style={{
          backgroundColor: "#f5f5f5",
        }}
        justifyContent="space-everly"
        flexDirection={["column", "column", "row"]}
        key="client-filter"
        alignItems="center"
      >
        <Box
          width={[1, 1, 1 / 4]}
          sx={{
            position: "relative",
          }}
          m={0}
          p={3}
          display={["none", "none", "block"]}
        >
          <Flex alignItems="center">
            <Box width={[1, 1, 1 / 6]} pr={2}>
              <Avatar name={agent} size={40}></Avatar>
            </Box>
            <Box width={[1, 1, 1]} pl={2}>
              <Text fontSize={[12, 12, 12]}>
                {getLocalizedString("Codice Agente")}{" "}
                <strong>{agentCode}</strong>
              </Text>
              <Text
                fontSize={[14, 14, 14]}
                sx={{
                  textTransform: "uppercase",
                  fontWeight: "bold",
                }}
              >
                {agent}
              </Text>
            </Box>
          </Flex>
        </Box>
        <Box
          width={[1, 1, 1 / 4]}
          sx={{
            position: "relative",
            marginLeft: "30px",
            paddingRight: "30px",
          }}
          display={["none", "none", "block"]}
        >
          <Input
            id="client"
            name="client"
            type="text"
            placeholder={getLocalizedString("Search filter")}
            style={{
              backgroundColor: "#fff",
              border: "none",
              fontSize: 12,
              paddingTop: 11,
              paddingBottom: 11,
            }}
            ref={searchBox}
            onKeyUp={changeQuery}
          />
          <Box
            sx={{
              position: "absolute",
              top: "6px",
              right: "30px",
            }}
            onClick={changeQueryClick}
          >
            <Search
              style={{
                color: "#fff",
                width: "24px",
                margin: 0,
                backgroundColor: "#fff",
                cursor: "pointer",
              }}
            />
          </Box>
        </Box>
        <Box
          width={[1, 1, 1 / 4]}
          ml="-5px"
          display={["none", "none", "block"]}
        >
          <Select
            styles={statusSelectStyle}
            placeholder={getLocalizedString("Select user status").toUpperCase()}
            name="status"
            id="orderStatus"
            components={{
              IndicatorSeparator: () => null,
              DropdownIndicator: (props) => (
                <components.DropdownIndicator {...props}>
                  <ChevronDown
                    style={{ width: 24, height: 24, color: "#3e3e3e" }}
                  />
                </components.DropdownIndicator>
              ),
            }}
            onChange={(option) => setStatus(option.value)}
            value={userStatusList.find((option) => option.value === status)}
            options={userStatusList}
            isSearchable={false}
          />
        </Box>
        {!isMobile && !isTabletSm && (
          <Flex width={[1, 1, "auto"]} m={0} p={3} justifyContent={"flex-end"}>
            <Button
              variant="primary"
              sx={{
                fontFamily: "Open Sans",
                fontSize: "0.8em",
                fontWeigth: 800,
                backgroundColor: "#545454",
                color: "white",
                textTransform: "uppercase",
                marginLeft: "20px",
                visibility:
                  searchBox?.current?.value || status !== "all"
                    ? "visible"
                    : "hidden",
                "&:hover": {
                  backgroundColor: "#909090",
                  color: "white",
                },
              }}
              onClick={clearQuery}
            >
              {getLocalizedString("CLEAR_FILTERS")}
            </Button>
          </Flex>
        )}
        {/* MOBILE FILTERS & SEARCH*/}
        <Flex
          flexDirection="column"
          display={["block", "block", "none"]}
          backgroundColor="#fff"
          width="100%"
        >
          <FiltersAndSearchMobile
            activeFilters={activeFilters}
            isFiltered={activeFilters?.length}
            onRemoveAllFilters={clearFilters}
            removeFilter={rmvHandler}
            ref={inputRef}
            onSearchSubmit={sendBtn}
            onSearchKeyUp={changeQuery}
            sx={{ mt: 0 }}
            {...filterProps}
          >
            <Flex
              bg="#DEDEDE"
              height="40px"
              width="100%"
              style={{ borderBottom: "2px solid #d2d2d2" }}
              px="10px"
              alignItems="center"
              justifyContent="space-between"
            >
              <span>{getLocalizedString("STATUS_CUSTOMER").toUpperCase()}</span>
            </Flex>
            <Flex flexDirection="column">
              {userStatusList.map((option, i) => (
                <Flex
                  key={`user-options-${i}-${option?.value}`}
                  height="40px"
                  px="10px"
                  alignItems="center"
                  bg="#f2f2f2"
                  mb="2px"
                  onClick={() => {
                    statusHandler(option.value, i);
                    filterProps.setOpenFilter(false);
                  }}
                >
                  <span>
                    {option.label.charAt(0).toUpperCase() +
                      option.label.toLowerCase().slice(1)}
                  </span>
                </Flex>
              ))}
            </Flex>
          </FiltersAndSearchMobile>
        </Flex>
        {/* END - MOBILE FILTERS & SEARCH*/}
      </Flex>
      <Flex
        display={["block", "none"]}
        mt="16px"
        sx={{ marginLeft: "24px", gap: "10px" }}
      >
        {userStatusList.map((status, index) => {
          if (status.value === "all") return null;
          else
            return (
              <Flex
                key={`user-status-${index}-${status.value}`}
                flexDirection={"row"}
                sx={{
                  fontSize: "0.8em",
                  cursor: "pointer",
                  "&:hover": { opacity: 0.8 },
                }}
                alignItems="center"
                onClick={() => statusHandler(status.value, index)}
              >
                <Box
                  backgroundColor={status.color}
                  width={14}
                  height={14}
                  mr={2}
                  style={{ borderRadius: "3px" }}
                ></Box>
                {status.label}
              </Flex>
            );
        })}
      </Flex>
    </>
  );
}

export { UsersFilter };
